var scope_0 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/12c6c0e4f8b014c5d72c8685a10f1532.js').default;
var scope_1 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/179cced02ba0d48ac1a86ebd4b97573e.js').default;
var scope_2 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1c984394b69cc4945fb01a25cba7ea73.js').default;
var scope_3 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1d27123b8eaefbbb1ab4cc44ed1cdbb7.js').default;
var scope_4 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/22bc6320adcec0baeea20ab9fd6756f6.js').default;
var scope_5 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/28a96bdad6798aed2d68663d07b74507.js').default;
var scope_6 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2982cc71a7ba25932377cf3890b1f6a8.js').default;
var scope_7 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2e7fdfb4c28b88e5380395841f97dc55.js').default;
var scope_8 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2fa293d9535fbb55479af673608a6779.js').default;
var scope_9 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/358ca7380781fca6dc7bdf9ec0d9fb40.js').default;
var scope_10 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3b780179e6094dd50e648a38489d464b.js').default;
var scope_11 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3c2cef2b570499bc4610385507ccf676.js').default;
var scope_12 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3e59c73d84066dc37fbd2214d3ed1000.js').default;
var scope_13 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3ebd5823c5990f0aefd9204270ac563e.js').default;
var scope_14 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3f3a3cf60fd71ce48e58587be309f77b.js').default;
var scope_15 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/43d465d8acada6dfbe543612a4d2e04a.js').default;
var scope_16 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4ee8fa935c3e0527d00166ef9fb4df14.js').default;
var scope_17 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4f04b3adf07180a15104bfcd71d80b73.js').default;
var scope_18 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/619c42c2b16a6cb8ce42cbbc70d6dd3c.js').default;
var scope_19 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/68514b783df4e7ade1747e020d39a9c4.js').default;
var scope_20 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/72cd49d82a655fc8b6f981cf650ee30a.js').default;
var scope_21 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/780b8cbae89c4d364c934a62cc390e88.js').default;
var scope_22 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7bc4af2eb8862c5741b3b5b32ba82926.js').default;
var scope_23 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7d2bfc9b549cc57186917a0d6b28c9ca.js').default;
var scope_24 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7fa1a35a7cecb7d4195af4501a1e4856.js').default;
var scope_25 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8527eec9e6be5b4201a7e638beb764db.js').default;
var scope_26 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/879dbb515b56bd0d1a4d8c4c90c66629.js').default;
var scope_27 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99c470974837e95d8eae235f608ea536.js').default;
var scope_28 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9dd2b609618b59cddfeb641536954ce5.js').default;
var scope_29 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a0cf4560d732dd4b5da7e702b1656980.js').default;
var scope_30 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a7882ecad7d0175e90c75b4964600f27.js').default;
var scope_31 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b5b56440feb6b812c79fbb2bdf2a36a1.js').default;
var scope_32 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b6a5e85e0249f8bef26026216697e01f.js').default;
var scope_33 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b9c3ed71f075f8bbdaae76df2e4dc3c6.js').default;
var scope_34 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c13c77553d49843a02db710b5adcf0f6.js').default;
var scope_35 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c31b34478d1495f6ad769aeb67ca473f.js').default;
var scope_36 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d222369c85dcd9964fb4ec1b4f7652ef.js').default;
var scope_37 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e4d574701debb244e91dab2376ff04b4.js').default;
var scope_38 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e57c396353785ce9a269254da45b80d2.js').default;
var scope_39 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e71018d695f1df332710be6fa3bc1976.js').default;
var scope_40 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_41 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eb7200331beaf5301bbeaabbfdcb8f96.js').default;
var scope_42 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f33db1f7d1592ea3b2a2aa8253055132.js').default;
var scope_43 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fcfb360a074cb5f9ddfa379ed5038459.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22,
scope_23,
scope_24,
scope_25,
scope_26,
scope_27,
scope_28,
scope_29,
scope_30,
scope_31,
scope_32,
scope_33,
scope_34,
scope_35,
scope_36,
scope_37,
scope_38,
scope_39,
scope_40,
scope_41,
scope_42,
scope_43 )
    